import apiClient from "./base.service.js";

export default {
    async getTicketTemplates(event) {
        return await apiClient.get(`/event/${event}/tickettemplate`);
    },
    async getTicketTemplate(event, id) {
        return await apiClient.get(`/event/${event}/tickettemplate/${id}`);
    },
    async createTicketTemplate(event, template, voucher, badge) {
        console.log(template);
        const form = new FormData();
        form.append('name', template.name);
        form.append('subject', template.subject);
        form.append('text', template.text);
        form.append('crewtemplate', template.crewtemplate);
        form.append('voucher_bounds_x', template.voucher_bounds.x);
        form.append('voucher_bounds_y', template.voucher_bounds.y);
        form.append('voucher_bounds_w', template.voucher_bounds.w);
        form.append('voucher_bounds_h', template.voucher_bounds.h);
        form.append('voucher_pdf_file', voucher.file);
        form.append('voucher_image_file', voucher.imgFormData)
        if (badge.file) {
            form.append('badge_pdf_file', badge.file);
            form.append('badge_image_file', badge.imgFormData);
            form.append('badge_bounds_x', template.badge_bounds.x);
            form.append('badge_bounds_y', template.badge_bounds.y);
            form.append('badge_bounds_w', template.badge_bounds.w);
            form.append('badge_bounds_h', template.badge_bounds.h);
        }
        return await apiClient.post(`/event/${event}/tickettemplate`, form, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            timeout: 0,
        });
    },
    async updateTicketTemplate(event, id, template, voucher, badge) {
        const form = new FormData();
        form.append('name', template.name);
        form.append('subject', template.subject);
        form.append('text', template.text);
        form.append('crewtemplate', template.crewtemplate);
        form.append('voucher_bounds_x', template.voucher_bounds.x);
        form.append('voucher_bounds_y', template.voucher_bounds.y);
        form.append('voucher_bounds_w', template.voucher_bounds.w);
        form.append('voucher_bounds_h', template.voucher_bounds.h);
        form.append('badge_bounds_x', template.badge_bounds.x);
        form.append('badge_bounds_y', template.badge_bounds.y);
        form.append('badge_bounds_w', template.badge_bounds.w);
        form.append('badge_bounds_h', template.badge_bounds.h);
        if (badge.file) {
            form.append('badge_image_file', badge.imgFormData);
            form.append('badge_pdf_file', badge.file);
        }
        if (voucher.file) {
            form.append('voucher_pdf_file', voucher.file);
            form.append('voucher_image_file', voucher.imgFormData)
        }
        return await apiClient.put(`/event/${event}/tickettemplate/${id}`, form, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            timeout: 0,
        });
    },
    async deleteTicketTemplate(event, id) {
        return await apiClient.delete(`/event/${event}/tickettemplate/${id}`);
    },
    async index() {
        return await apiClient.get('/ticket');
    },
    async resendTicket(event, id) {
        return await apiClient.put(`/event/${event}/ticket/${id}/resend`);
    }
}